import { Routes, Route } from 'react-router-dom'
import { UserProvider } from '@/contexts/UserContext'
import Layout from '@/components/Layout'
import FirebaseInitializer from '@/components/FirebaseInitializer'
import HomePage from '@/pages/HomePage'
import SimpleLoginPage from '@/pages/SimpleLoginPage'
import SimpleRegisterPage from '@/pages/SimpleRegisterPage'
import DashboardPage from '@/pages/DashboardPage'
import FoodBanksPage from '@/pages/FoodBanksPage'
import NearbyMapPage from '@/pages/NearbyMapPage'
import SuppliersPage from '@/pages/SuppliersPage'
import VolunteersPage from '@/pages/VolunteersPage'
import VolunteerProfilePage from '@/pages/VolunteerProfilePage'
import ProfilePage from '@/pages/ProfilePage'
import BlogPage from '@/pages/BlogPage'
import OurStoryPage from '@/pages/OurStoryPage'
import HowItWorksPage from '@/pages/HowItWorksPage'
import ContactPage from '@/pages/ContactPage'
import StoriesPage from '@/pages/StoriesPage'
import StoryDetailPage from '@/pages/StoryDetailPage'
import CreateStoryPage from '@/pages/CreateStoryPage'
import AdminStoriesPage from '@/pages/AdminStoriesPage'
import AdminFoodBanksPage from '@/pages/AdminFoodBanksPage'
import AdminApprovalsPage from '@/pages/AdminApprovalsPage'
import AdminFeedbackPage from '@/pages/AdminFeedbackPage'
import DeliveryDetailsPage from '@/pages/DeliveryDetailsPage'
import DeliveriesPage from '@/pages/DeliveriesPage'
import VolunteerOnboarding from '@/components/VolunteerOnboarding'
import FoodBankOnboarding from '@/components/FoodBankOnboarding'
import SupplierOnboarding from '@/components/SupplierOnboarding'
import ImageDebug from '@/components/ImageDebug'
import ArchivedSupplierDeliveriesPage from '@/pages/ArchivedSupplierDeliveriesPage'
import ArchivedFoodBankRequestsPage from '@/pages/ArchivedFoodBankRequestsPage'
import VerifyEmailPage from '@/pages/VerifyEmailPage'
import VerifyPhonePage from '@/pages/VerifyPhonePage'
import BusinessVerificationPage from '@/pages/BusinessVerificationPage'

function App() {
  return (
    <UserProvider>
      <FirebaseInitializer />
      <div className="min-h-screen bg-neutral-50">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="login" element={<SimpleLoginPage />} />
            <Route path="register" element={<SimpleRegisterPage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="food-banks" element={<FoodBanksPage />} />
            <Route path="nearby-map" element={<NearbyMapPage />} />
            <Route path="suppliers" element={<SuppliersPage />} />
            <Route path="volunteers" element={<VolunteersPage />} />
            <Route path="volunteers/:id" element={<VolunteerProfilePage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="verify-email" element={<VerifyEmailPage />} />
            <Route path="verify-phone" element={<VerifyPhonePage />} />
            <Route path="business-verification" element={<BusinessVerificationPage />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="our-story" element={<OurStoryPage />} />
            <Route path="how-it-works" element={<HowItWorksPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="stories" element={<StoriesPage />} />
            <Route path="stories/:id" element={<StoryDetailPage />} />
            <Route path="stories/create" element={<CreateStoryPage />} />
            <Route path="admin/stories" element={<AdminStoriesPage />} />
            <Route path="admin/food-banks" element={<AdminFoodBanksPage />} />
            <Route path="admin/approvals" element={<AdminApprovalsPage />} />
            <Route path="admin/feedback" element={<AdminFeedbackPage />} />
            <Route path="deliveries" element={<DeliveriesPage />} />
            <Route path="delivery/:id" element={<DeliveryDetailsPage />} />
            <Route path="supplier/archived" element={<ArchivedSupplierDeliveriesPage />} />
            <Route path="food-bank/requests/archived" element={<ArchivedFoodBankRequestsPage />} />
            <Route path="onboarding" element={<VolunteerOnboarding />} />
            <Route path="food-bank-onboarding" element={<FoodBankOnboarding />} />
            <Route path="supplier-onboarding" element={<SupplierOnboarding />} />
            <Route path="debug-images" element={<ImageDebug />} />
          </Route>
        </Routes>
      </div>
    </UserProvider>
  )
}

export default App 